import React from "react";
import { FaGithub } from "react-icons/fa6";
import { openInNewTab } from "../Helper/helper";

function OtherWork() {
    return (
        <div className="mx-auto pt-6 py-6">
            <div className="text-center py-6">
                If you would like to view some of my other web development
                projects and even game development and other languages, please
                check out my github.
            </div>
            <FaGithub
                className="text-6xl hover:scale-125 transition-all mx-auto hover:cursor-pointer"
                onClick={() => openInNewTab("https://github.com/jack-king1")}
            />
        </div>
    );
}

export default OtherWork;
